import { Component, Input, OnInit } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Component({
    selector: 'app-consult-note-estimated-values',
    templateUrl: './consult-note-estimated-values.component.html',
    styleUrls: ['./consult-note-estimated-values.component.scss'],
    imports: [CurrencyPipe]
})
export class ConsultNoteEstimatedValuesComponent implements OnInit {
  @Input() patientAttachment: { wipEstimatedValue: number; pendingEstimatedValue: number };

  constructor() {}

  ngOnInit() {}
}
